import { IconKind, VisualShape } from 'app/frontend/types/custom/VisualPlan'

export const SIDEBAR_DRAG_MIME = 'application/x-wowaudit-visual-sidebar'

export type SidebarDragPayload =
  | {
      kind: 'shape'
      type: Exclude<VisualShape['type'], 'icon' | 'text' | 'pencil'>
    }
  | { kind: 'text' }
  | { kind: 'icon'; iconKind: IconKind; value: string }

type WowheadPower = {
  hideTooltip?: () => void
}

export const hideSidebarTooltips = () => {
  const wowhead = (window as Window & { $WowheadPower?: WowheadPower })
    .$WowheadPower
  wowhead?.hideTooltip?.()
}

export const setSidebarDragData = (
  dataTransfer: DataTransfer,
  payload: SidebarDragPayload,
) => {
  dataTransfer.setData(SIDEBAR_DRAG_MIME, JSON.stringify(payload))
  dataTransfer.effectAllowed = 'copy'
}

export const parseSidebarDragData = (
  dataTransfer: DataTransfer,
): SidebarDragPayload | null => {
  const raw = dataTransfer.getData(SIDEBAR_DRAG_MIME)
  if (!raw) return null
  return JSON.parse(raw) as SidebarDragPayload
}

export const hasSidebarDragData = (dataTransfer: DataTransfer) =>
  Array.from(dataTransfer.types).includes(SIDEBAR_DRAG_MIME)
